import { render } from "./TDBG_SRLQ.vue?vue&type=template&id=ed9ad9ee&scoped=true"
import script from "./TDBG_SRLQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRLQ.vue?vue&type=script&lang=js"

import "./TDBG_SRLQ.vue?vue&type=style&index=0&id=ed9ad9ee&scoped=scoped&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9ad9ee"]])

export default __exports__